var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class HttpRequest {
    constructor(url) {
        this.params = [];
        this.headers = {};
        this.method = 'GET';
        this.payload = null;
        this.url = url;
    }
    setMethod(method) {
        this.method = method;
        return this;
    }
    setHeader(name, value) {
        this.headers[name] = value;
        return this;
    }
    addParam(name, value) {
        this.params.push({ name, value });
        return this;
    }
    setPayload(payload) {
        this.payload = payload;
        return this;
    }
    /**
     * Gets the result url, with query params appended.
     */
    getUrl() {
        let url = this.url;
        if (this.params != null) {
            let i = 0;
            if (url.indexOf('?') < 0) {
                url += '?';
            }
            else {
                i++;
            }
            for (const param of this.params) {
                if (i > 0) {
                    url += "&";
                }
                var key = param.name;
                var value = param.value;
                if (value != null) {
                    url += key + "=" + encodeURIComponent(value);
                    i++;
                }
            }
        }
        return url;
    }
    execute() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.getUrl();
            const fetchOptions = {
                method: this.method,
                headers: this.headers,
            };
            // Add body for non-GET requests
            if (this.payload && this.method !== 'GET') {
                if (typeof this.payload === 'string') {
                    fetchOptions.body = this.payload;
                }
                else {
                    fetchOptions.body = JSON.stringify(this.payload);
                    // Ensure content-type is set for JSON payloads
                    if (!this.headers['Content-Type'] && !this.headers['content-type']) {
                        fetchOptions.headers = Object.assign(Object.assign({}, this.headers), { 'Content-Type': 'application/json' });
                    }
                }
            }
            const response = yield fetch(url, fetchOptions);
            // Parse response body
            let data;
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                data = yield response.json();
            }
            else {
                data = yield response.text();
            }
            // Return axios-compatible response structure
            return {
                data: data,
                status: response.status,
                headers: response.headers
            };
        });
    }
}
//# sourceMappingURL=http-request.js.map